import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export type ThinkingState = 'thinking' | 'done';

@Component({
  selector: 'fyxt-thinking-ui',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './thinking-ui.component.html',
  styleUrls: ['./thinking-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThinkingUiComponent {
  @Input() state: ThinkingState = 'thinking';
  @Input() titleThinking = 'Thinking';
  @Input() titleDone = 'Finished thinking';
  @Input() subtitle = '';
  @Input() expanded = false;
  @Input() collapsible = true;
  @Input() thoughts: string[] = [];

  toggle(): void {
    if (!this.collapsible) return;
    this.expanded = !this.expanded;
  }

  trackByIndex(index: number): number {
    return index;
  }
}

